import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TABS = [
  {
    id: "button",
    label: "Botón de Compra",
    path: "/button-editor",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </svg>
    ),
  },
  {
    id: "form",
    label: "Diseñador",
    path: "/editor",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.836-.437-1.124-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
      </svg>
    ),
  },
  {
    id: "shipping",
    label: "Tarifas de Envío",
    path: "/shipping-editor",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11" />
        <path d="M14 9h4l4 4v5c0 .6-.4 1-1 1h-2" />
        <circle cx="7" cy="18" r="2" />
        <circle cx="17" cy="18" r="2" />
      </svg>
    ),
  },
] as const;

interface EditorNavHeaderProps {
  leftContent?: React.ReactNode;
  children?: React.ReactNode;
}

export const EditorNavHeader: React.FC<EditorNavHeaderProps> = ({
  leftContent,
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <header className="bg-[#f1f1f1] w-full shrink-0 z-30 relative pt-5 pb-4 px-6">
      <div className="grid grid-cols-[1fr_auto_1fr] items-center w-full">
        <div className="flex items-center justify-start gap-4">
          {leftContent}
        </div>

        {/* Centro: Navegación Principal */}
        <div className="flex items-center justify-center">
          <nav className="flex items-center bg-white p-1 rounded-full shadow-sm border border-gray-200/50">
            {TABS.map((tab) => {
              const isActive = currentPath === tab.path;
              return (
                <button
                  key={tab.id}
                  onClick={() => {
                    if (!isActive) navigate(tab.path);
                  }}
                  className={`flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-full transition-all ${
                    isActive
                      ? "bg-gray-100 text-gray-900 shadow-[0_1px_2px_rgba(0,0,0,0.05)]"
                      : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {tab.icon}
                  <span className="hidden lg:inline">{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>

        <div className="flex items-center justify-end gap-4">{children}</div>
      </div>
    </header>
  );
};
